/**
 * Centralized route names enum
 * All route names should be defined here and referenced from routes
 * This ensures type safety and prevents typos
 */
export enum RouteNames {
  // System routes
  ROOT = "Root",
  NOT_FOUND = "NotFound",
  FORBIDDEN = "Forbidden",
  DONT_HAVE_PERMISSION = "DontHavePermission",

  // Auth routes
  LOGIN = "Login",
  FORGET_PASSWORD = "ForgetPassword",
  REST_PASSWORD = "ResetPassword",
  PASSWORD_CHANGE = "PasswordChange",
  MCP_CONSENT = "McpConsent",

  // Core feature routes
  SOINSIGHTFUL = "SOInsightful",
  SALES_AND_TRAFFIC = "SalesAndTraffic",
  PRODUCT_RETURNS = "ProductReturns",
  ADVERTISING_SUMMARY = "AdvertisingSummary",
  ADVERTISING_SUMMARY_VENDOR = "AdvertisingSummaryVendor",
  ADVERTISING_PERFORMANCE = "AdvertisingPerformance",
  ADVERTISING_ANALYTICS = "AdvertisingAnalytics",
  REVIEWS = "Reviews",
  BRAND_PROTECTION = "BrandProtection",
  CAMPAIGNS = "Campaigns",
  INVENTORY = "Inventory",
  ALERTS = "ProductAlerts",
  PERFORMANCE = "ProductPerformance",
  HEALTH = "AccountHealth",
  WAREHOUSE = "Warehouse",
  CUSTOMER_ANALYTICS = "CustomerAnalytics",
  ZINUS_CALCULATOR = "ZinusCalculator",
  FUNNEL_PERFORMANCE = "FunnelPerformance",
  PRODUCT_REVIEWS = "ProductReviews",
  COMMUNICATION = "Communication",
  PROFIT_ANALYSIS = "ProfitAnalysis",
  COMPETITOR = "Competitor",
  CATEGORY = "CategoryAnalysis",
  BUSINESS_REVIEW = "BusinessReview",

  // Admin routes
  USERS = "Users",
  EDIT_USER = "EditUser",
  AI_USAGE = "AiUsage",
  AI_GENERATIONS = "AiGenerations",
  AI_FEATURES = "LlmFeatures",
  /** The whole MCP screen. The call list is a tab on it, not a route of its own. */
  MCP_USAGE = "McpUsage",
  /** Retired screen, kept as a redirect: the name is in bookmarks. */
  AI_SUMMARY_SETTINGS = "AiSummarySettings",
  AI_PROMPT = "AiPrompt",
}
